module.exports = __webpack_public_path__ + "img/btn.90927dc8.png";